"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = ['AL', 'AZ', 'CO', 'DE', 'FL', 'GA', 'ID', 'IL', 'IN', 'IA', 'KS', 'MS', 'MT', 'NE', 'NV', 'NC', 'ND', 'OH', 'OK', 'SC', 'SD', 'TN', 'VA', 'WY'];
exports["default"] = _default;